import { Box } from "@chakra-ui/react";
import { H4 } from "src/atoms/typography";
import { Device, ThisDevice } from "./devices";

export default function DeviceList({
  familyDevices,
  otherDevices,
  thisDevice,
  familyName,
  handleFamilyDeviceRemoval,
  handleOtherDeviceRemoval,
  handleDeviceRename,
  t
}) {
  const hasOtherDevices = otherDevices.length > 0;
  let otherDevicesHeading = hasOtherDevices
    ? t("pairedDevices.otherDevices")
    : null;

  let myDevicesHeading;

  const hasNamedFamily = typeof familyName === "string";
  if (hasNamedFamily) {
    myDevicesHeading = familyName;
  } else if (hasOtherDevices) {
    myDevicesHeading = t("pairedDevices.myDevices");
  }

  return (
    <>
      {myDevicesHeading && (
        <H4 color="highEmphasis" ml="24px" mb="8px">
          {myDevicesHeading}
        </H4>
      )}
      <ThisDevice
        device={thisDevice}
        onRename={() => handleDeviceRename(thisDevice)}
      />
      {familyDevices.map((device) => (
        <Device
          onRemove={() => handleFamilyDeviceRemoval(device)}
          onRename={() => handleDeviceRename(device)}
          {...device}
          key={device.jid}
        />
      ))}
      {hasOtherDevices && (
        <>
          <H4 color="highEmphasis" ml="24px" mt="16px" mb="8px">
            {otherDevicesHeading}
          </H4>
          <Box>
            {otherDevices.map((device) => (
              <Device
                onRemove={() => handleOtherDeviceRemoval(device)}
                {...device}
                key={device.jid}
              />
            ))}
          </Box>
        </>
      )}
    </>
  );
}
